export default "__VITE_ASSET__DDMwyXZi__"